module.exports = __webpack_public_path__ + "img/brandLogoColor.f8477ae7.png";